import { gql } from '@apollo/client';

const MENU_SCHEMA_QUERY = gql`
  query Query($input: fetchMenuSchema) {
    MenuSchema(input: $input)
  }
`;

export default MENU_SCHEMA_QUERY;
